var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW2Prules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconrules"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.8,1.45A1.44,1.44,0,0,0,11.38,0H3.22A1.36,1.36,0,0,0,1.87,1.37l-.06,7.5H0v1.28A1.82,1.82,0,0,0,1.73,12h7a1.81,1.81,0,0,0,1.8-1.83V3.56H12.8Zm-11,10A1.27,1.27,0,0,1,.54,10.17V9.42H6.9v.73a1.88,1.88,0,0,0,.51,1.28ZM10,1.45v8.72a1.27,1.27,0,1,1-2.53,0V8.87H2.35l.06-7.5A.82.82,0,0,1,3.22.55h7A1.46,1.46,0,0,0,10,1.45ZM12.26,3H10.51V1.45a.91.91,0,0,1,.41-.87.85.85,0,0,1,.94,0,.92.92,0,0,1,.4.87Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.55,
    y: 5.61,
    width: 5.07,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    "data-name": "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.55,
    y: 7.27,
    width: 5.07,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "W2P",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.74,3.87l.22,1L5,5H5l0-.16.19-1h.33l-.35,1.5H4.78l-.2-1,0-.16h0l0,.16-.19,1H3.92l-.35-1.5h.35l.19,1,0,.16h0l0-.16.21-1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.74,4.29a.41.41,0,0,1,0,.19.76.76,0,0,1-.12.19,1.62,1.62,0,0,1-.18.2l-.23.2h.57v.29h-1V5.15L6,4.9a2.27,2.27,0,0,0,.22-.22.77.77,0,0,0,.14-.19.28.28,0,0,0,.05-.17.15.15,0,0,0-.05-.13.3.3,0,0,0-.18-.05.41.41,0,0,0-.19,0,.56.56,0,0,0-.17.09L5.73,4A.9.9,0,0,1,6,3.89a.79.79,0,0,1,.28,0,.73.73,0,0,1,.22,0A.35.35,0,0,1,6.61,4a.28.28,0,0,1,.1.14A.48.48,0,0,1,6.74,4.29Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.14,4.38a.46.46,0,0,1,0,.21.39.39,0,0,1-.1.16.44.44,0,0,1-.18.09.7.7,0,0,1-.27,0h-.2v.49H7V3.87h.54A.67.67,0,0,1,8,4,.51.51,0,0,1,8.14,4.38Zm-.35,0a.31.31,0,0,0,0-.11.21.21,0,0,0,0-.07l-.08,0H7.35v.46h.31l.07,0a.13.13,0,0,0,0-.07A.37.37,0,0,0,7.79,4.38Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW2Prules);
export default __webpack_public_path__ + "static/media/w2prules.32f8b2743f484b7b7ffff124bb7818a2.svg";
export { ForwardRef as ReactComponent };